import DashboardNoticeItem from "./DashboardNoticeItem";

export default DashboardNoticeItem;